import { useContext, useEffect, useRef, useState } from "react";
import { EditableContext } from "../../../context/CollectionEditableRowContext";


export const useEditableCellTable = ({    
    dataIndex,
    record,
    handleSave, 
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    return {
        toggleEdit,
        save,
        editing,
        inputRef
    }
}